// Each page is its own chunk, fetched on first visit. App wraps them in Suspense.
import { lazy } from "react";

// Vision UI Dashboard PRO React layouts
// import Default from "layouts/dashboards/default";
// import CRM from "layouts/dashboards/crm";
// import ProfileOverview from "layouts/pages/profile/profile-overview";
// import Teams from "layouts/pages/profile/teams";
// import AllProjects from "layouts/pages/profile/all-projects";
// import Reports from "layouts/pages/users/reports";
const NewUser = lazy(() => import("layouts/pages/users/new-user"));
// import Settings from "layouts/pages/account/settings";
// import Billing from "layouts/pages/account/billing";
// import Invoice from "layouts/pages/account/invoice";
// import General from "layouts/pages/projects/general";
// import Timeline from "layouts/pages/projects/timeline";
// import Widgets from "layouts/pages/widgets";
// import Charts from "layouts/pages/charts";
// import Alerts from "layouts/pages/alerts";
// import PricingPage from "layouts/pages/pricing-page";
// import RTL from "layouts/pages/rtl";
// import Kanban from "layouts/applications/kanban";
// import Wizard from "layouts/applications/wizard";
// import DataTables from "layouts/applications/data-tables";
// import Calendar from "layouts/applications/calendar";
// import NewProduct from "layouts/ecommerce/products/new-product";
// import EditProduct from "layouts/ecommerce/products/edit-product";
// import ProductPage from "layouts/ecommerce/products/product-page";
// import OrderDetails from "layouts/ecommerce/orders/order-details";

const SignInIllustration = lazy(() => import("layouts/authentication/sign-in/illustration"));

// Custompages
const Dashboard = lazy(() => import("layouts/pages/dashboard"));
const OperationsList = lazy(() => import("layouts/pages/operations/list"));
const AddOperation = lazy(() => import("layouts/pages/operations/add"));
const TransactionsList = lazy(() => import("layouts/pages/transactions/list"));
const UsersList = lazy(() => import("layouts/pages/users/list"));
const UserActions = lazy(() => import("layouts/pages/users/user-actions-log"));
const EditUser = lazy(() => import("layouts/pages/users/edit"));
const Faq = lazy(() => import("layouts/pages/faq/list"));
const AddFAQ = lazy(() => import("layouts/pages/faq/add"));
const AddFAQCategory = lazy(() => import("layouts/pages/faq/addcategory"));
const FaqCategories = lazy(() => import("layouts/pages/faq/listcategory"));
const News = lazy(() => import("layouts/pages/news/list"));
const ReportsGeneratorConfigs = lazy(() => import("layouts/pages/reports-generator/operations-list/list"));
const ReportsGeneratorConfigsAdd = lazy(() => import("layouts/pages/reports-generator/operations-list/add"));
const ReportsGeneratorProjectsList = lazy(() => import("layouts/pages/reports-generator/projects-list/list"));
const ReportsGeneratorAddProject = lazy(() => import("layouts/pages/reports-generator/projects-list/add"));
const ReportsGeneratorStart = lazy(() => import("layouts/pages/reports-generator/start"));
const ReportsGeneratedData = lazy(() => import("layouts/pages/reports-generator/data"));
const GeneratedReports = lazy(() => import("layouts/pages/reports-generator/generated-reports"));

const AddNews = lazy(() => import("layouts/pages/news/add"));
const AddCashflow = lazy(() => import("layouts/pages/settings/cashflowSystem/add"));
const SendIncomes = lazy(() => import("layouts/pages/payment-systems/send-incomes"));
const AddPs = lazy(() => import("layouts/pages/payment-systems/add"));
const AddApi = lazy(() => import("layouts/pages/payment-systems/api-providers"));
const NewApi = lazy(() => import("layouts/pages/payment-systems/new-api"));
const PaymentSystems = lazy(() => import("layouts/pages/payment-systems/list"));
const DepositsList = lazy(() => import("layouts/pages/deposits/list"));
const DepositAdd = lazy(() => import("layouts/pages/deposits/add"));
const EditDeposit = lazy(() => import("layouts/pages/deposits/edit"));
const EditTransaction = lazy(() => import("layouts/pages/transactions/edit"));
const Tickets = lazy(() => import("layouts/pages/tickets/list"));
const Ticket = lazy(() => import("layouts/pages/tickets/ticket"));
const Plans = lazy(() => import("layouts/pages/plans/list"));
const AddPlan = lazy(() => import("layouts/pages/plans/add"));
const Languages = lazy(() => import("layouts/pages/settings/languages"));
const Notifications = lazy(() => import("layouts/pages/settings/notifications"));
const SettingsDepositLimits = lazy(() => import("layouts/pages/settings/DepositsLimits"));
const ConversionPlans = lazy(() => import("layouts/pages/settings/conversionPlans/list"));
const AddConversionPlan = lazy(() => import("layouts/pages/settings/conversionPlans/add"));
const Promocodes = lazy(() => import("layouts/pages/settings/promocodes"));
const PromocodesEdit = lazy(() => import("layouts/pages/settings/promocodes/addedit"));
const PromocodesAdd = lazy(() => import("layouts/pages/settings/promocodes/addedit"));
const CryptoAddressesGenerator = lazy(() => import("layouts/pages/settings/cryptoAddressesGenerator/list"));
const AddCryptoAddressesGenerator = lazy(() => import("layouts/pages/settings/cryptoAddressesGenerator/add"));
const General = lazy(() => import("layouts/pages/settings/general"));
const GeneralSettings = lazy(() => import("layouts/pages/settings/generalSettings"));
const EmailService = lazy(() => import("layouts/pages/settings/emailService"));
const Tags = lazy(() => import("layouts/pages/news/tags"));
const TradesHistory = lazy(() => import("layouts/pages/trades/trades-history"));
const CreateDeals = lazy(() => import("layouts/pages/trades/create-deals"));
const CreateDeal = lazy(() => import("layouts/pages/trades/add-deal"));
const Agents = lazy(() => import("layouts/pages/trades/agents"));
const Agent = lazy(() => import("layouts/pages/trades/agent"));
const AddPage = lazy(() => import("layouts/pages/pages-seo/add-page"));
const PagesSeoList = lazy(() => import("layouts/pages/pages-seo/pages-seo-list"));
const StuckFunds = lazy(() => import("layouts/pages/stuck-funds/list"));
// import Withdrawal from "layouts/pages/withdrawal";

// React icons
import { IoDocument, IoBuild, IoDocuments, IoHome, IoLogoBitcoin, IoTime, IoPeople, IoBook, IoNewspaper, IoJournal, IoHelpBuoy, IoRocket, IoWallet } from "react-icons/io5";
import { AiFillFund } from "react-icons/ai";


const routes = [
  // {
  //   type: "collapse",
  //   name: "Dashboard",
  //   key: "dashboards",
  //   icon: <IoHome size="15px" color="inherit" />,
  //   collapse: [
  //     {
  //       name: "Dashboard",
  //       key: "Dashboard",
  //       route: "/dashboard",
  //       component: Dashboard,
  //       isPrivate: true
  //     },
  //   ],
  // },
  { 
    type: "link", 
    route: "/dashboard", 
    name: "Dashboard", 
    component: Dashboard, 
    key: "Dashboard", 
    icon: <IoHome size="15px" color="inherit" />, 
  },
  // {
  //   type: "collapse",
  //   name: "Withdrawal funds",
  //   key: "withdrawal",
  //   icon: <IoJournal size="15px" color="inherit" />,
  //   collapse: [
  //     {
  //       name: "Withdrawal funds",
  //       key: "withdrawal-funds",
  //       route: "/withdrawal",
  //       component: Withdrawal,
  //       isPrivate: true
  //     },
  //   ],
  // },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    icon: <IoPeople size="15px" color="inherit" />,
    allwaysShow: true,
    mainLink: "/users/all-users",
    collapse: [
      {
        name: "All users",
        key: "all-users",
        route: "/users/all-users",
        component: UsersList,
        isPrivate: true
      },
      {
        name: "New User",
        key: "new-user",
        route: "/pages/users/new-user",
        component: NewUser,
      },
      {
        name: "User action log",
        key: "user-actions-log",
        route: "/pages/users/user-actions-log",
        component: UserActions,
      }
      // {
      //   name: "Add user",
      //   key: "add-user",
      //   route: "/users/user",
      //   component: User,
      // },
    ],
  },
  {
    type: "collapse",
    name: "Operations",
    key: "operations",
    icon: <IoDocument size="15px" color="inherit" />,
    allwaysShow: true,
    mainLink: "/operations/all-opertaions",
    collapse: [
      {
        name: "All operations",
        key: "all-operations",
        route: "/operations/all-opertaions",
        component: OperationsList,
        isPrivate: true
      },
      {
        name: "Add operation",
        key: "add-operation",
        route: "/operations/add-opertaion",
        component: AddOperation,
        isPrivate: true
      },
    ],
  },
  // { 
  //   type: "link", 
  //   route: "/transactions/all-transactions", 
  //   name: "Transactions", 
  //   component: TransactionsList, 
  //   key: "all-transactions", 
  //   icon: <IoTime size="15px" color="inherit" />, 
  // },
  // {
  //   type: "collapse",
  //   name: "Transactions",
  //   key: "transactions",
  //   icon: <IoTime size="15px" color="inherit" />,
  //   collapse: [
  //     {
  //       name: "All transactions",
  //       key: "all-transactions",
  //       route: "/transactions/all-transactions",
  //       component: TransactionsList,
  //       isPrivate: true
  //     },
  //   ],
  // },
  {
    type: "collapse",
    name: "Transactions", 
    key: "transactions",
    icon: <IoTime size="15px" color="inherit" />,
    allwaysShow: true,
    mainLink: "/transactions/all-transactions",
    collapse: [
      {
        name: "Pending transactions",
        key: "withdrawal_pending_tx",
        route: "/transactions/pending-transactions",
        component: TransactionsList,
        data: { pending: true }
      },
      {
        name: "Stucked transactions",
        key: "stucked_forwards_tx",
        route: "/transactions/stucked-forwards",
        component: TransactionsList,
        data: { stucked: true }
      },
    ],
  },
  {
    type: "collapse",
    name: "Deposits",
    key: "deposits",
    icon: <IoLogoBitcoin size="15px" color="inherit" />,
    allwaysShow: true,
    mainLink: "/deposits/all-deposits",
    collapse: [
      {
        name: "All deposits",
        key: "all-deposits",
        route: "/deposits/all-deposits",
        component: DepositsList,
      },
      {
        name: "Create deposit",
        key: "create-deposits",
        route: "/deposits/create-deposit",
        component: DepositAdd,
      },
    ],
  },
  {
    type: "collapse",
    name: "Payment systems",
    key: "payment-systems",
    icon: <IoLogoBitcoin size="15px" color="inherit" />,
    collapse: [
      {
        name: "Payment systems",
        key: "ps",
        route: "/payment-systems",
        component: PaymentSystems,
        isPrivate: true
      },
      {
        name: "Add payment system",
        key: "add-ps",
        route: "/payment-systems/add-ps",
        component: AddPs,
        isPrivate: true
      },
      {
        name: "Add API",
        key: "add-api",
        route: "/payment-systems/add-api",
        component: AddApi,
        isPrivate: true
      },
      {
        name: "Send incomes",
        key: "send-incomes",
        route: "/payment-systems/send-incomes",
        component: SendIncomes,
        isPrivate: true
      },
    ],
  },
  { 
    type: "link", 
    route: "/stuck-funds", 
    name: "Stuck funds", 
    component: StuckFunds, 
    key: "stuck-funds", 
    icon: <IoWallet size="15px" color="inherit" />, 
  },
  {
    type: "collapse",
    name: "Plans",
    key: "plans",
    icon: <IoRocket size="15px" color="inherit" />,
    collapse: [
      {
        name: "Plans",
        key: "all-plans",
        route: "/plans",
        component: Plans,
        isPrivate: true
      },
      {
        name: "Add plan",
        key: "add-plan",
        route: "/plans/add-plan",
        component: AddPlan,
        isPrivate: true
      },
    ],
  },
  {
    type: "collapse",
    name: "Settings",
    key: "settings",
    icon: <IoBuild size="15px" color="inherit" />,
    mainLink: "/general-settings",
    collapse: [
      {
        name: "General",
        key: "general",
        route: "/general",
        component: General
      },
      {
        name: "General settings",
        key: "general-settings",
        route: "/general-settings",
        component: GeneralSettings
      },
      {
        name: "Languages",
        key: "languages",
        route: "/languges",
        component: Languages,
      },
      {
        name: "Notifications",
        key: "notifications",
        route: "/notifications",
        component: Notifications,
      },
      {
        name: "E-Mail Service",
        key: "email-service",
        route: "/email-service",
        component: EmailService,
      },
      {
        name: "Deposit limits",
        key: "deposit-limits",
        route: "/deposit-limits",
        component: SettingsDepositLimits,
      },
      {
        name: "Cashflow system",
        key: "cashflow-system",
        route: "/cashflow-system/add",
        component: AddCashflow,
      },
      {
        name: "Conversion plans",
        key: "conversion-plans",
        route: "/conversion-plans",
        component: ConversionPlans
      },
      {
        name: "Promocode types",
        key: "promocodes",
        route: "/promocodes",
        component: Promocodes
      },
      {
        name: "Crypto address generator",
        key: "crypto-addresses-generator",
        route: "/crypto-addresses-generator",
        component: CryptoAddressesGenerator
      }
    ],
  },
  {
    type: "collapse",
    name: "FAQ",
    key: "faq",
    icon: <IoBook size="15px" color="inherit" />,
    collapse: [
      {
        name: "List",
        key: "faq-list",
        route: "/faq/faq-list",
        component: Faq,
        isPrivate: true
      },
      {
        name: "Add",
        key: "faq-add",
        route: "/faq/add",
        component: AddFAQ,
        isPrivate: true
      },
      {
        name: "Category list",
        key: "faq-list-categories",
        route: "/faq/categorieslist",
        component: FaqCategories,
        isPrivate: true
      },
      {
        name: "Add category",
        key: "faq-category-add",
        route: "/faq/add-category",
        component: AddFAQCategory,
        isPrivate: true
      },
    ],
  },
  {
    type: "collapse",
    name: "News",
    key: "news",
    icon: <IoNewspaper size="15px" color="inherit" />,
    collapse: [
      {
        name: "All news",
        key: "all-news",
        route: "/news/all-news",
        component: News,
        isPrivate: true
      },
      {
        name: "Add",
        key: "add-news",
        route: "/news/add",
        component: AddNews,
        isPrivate: true
      },
      {
        name: "Tags",
        key: "tags",
        route: "/tags",
        component: Tags,
        isPrivate: true
      },
    ],
  },
  { 
    type: "link", 
    route: "/tickets/all-tickets", 
    name: "Tickets", 
    component: Tickets, 
    key: "tickets", 
    icon: <IoHelpBuoy size="15px" color="inherit" />, 
  },
  {
    type: "collapse",
    name: "Reports Generator",
    key: "reports-generator",
    icon: <IoNewspaper size="15px" color="inherit" />,
    collapse: [
      {
        name: "Projects list",
        key: "projects-list",
        route: "/reports-generator/projects-list",
        component: ReportsGeneratorProjectsList,
        isPrivate: true
      },
      {
        name: "Operations list",
        key: "operations-list",
        route: "/reports-generator/operations-list",
        component: ReportsGeneratorConfigs,
        isPrivate: true
      },
      // {
      //   name: "Operations names list",
      //   key: "operations-names-list",
      //   route: "/reports-generator/operations-list",
      //   component: ReportsGeneratorConfigs,
      //   isPrivate: true
      // },
      {
        name: "Add project",
        key: "project",
        route: "/reports-generator/project",
        component: ReportsGeneratorAddProject,
        isPrivate: true
      },
      {
        name: "Add operation config",
        key: "add-operation-config",
        route: "/reports-generator/add-operation",
        component: ReportsGeneratorConfigsAdd,
        isPrivate: true
      },
      // {
      //   name: "Add operation name with chance",
      //   key: "add-operation-name-with-chance",
      //   route: "/reports-generator/add",
      //   component: ReportsGeneratorConfigsAdd,
      //   isPrivate: true
      // },
      {
        name: "Start reports generator",
        key: "start-generator",
        route: "/reports-generator/start-generator",
        component: ReportsGeneratorStart,
        isPrivate: true
      },
      {
        name: "Generated data",
        key: "generated-data",
        route: "/reports-generator/generated-data",
        component: ReportsGeneratedData,
        isPrivate: true
      },
      {
        name: "Generated reports",
        key: "generated-reports",
        route: "/reports-generator/generated-reports",
        component: GeneratedReports,
        isPrivate: true
      }
    ],
  },
  {
    type: "collapse",
    name: "Rates trading",
    key: "trades-history",
    icon: <AiFillFund size="15px" color="inherit" />,
    mainLink: "/trades-history",
    collapse: [
      {
        name: "Create deals",
        key: "create-deals",
        route: "/trades-history/create-deals",
        component: CreateDeals,
        isPrivate: true
      },
      {
        name: "Create deal",
        key: "deal",
        route: "/trades-history/deal",
        component: CreateDeal,
        isPrivate: true
      },
      {
        name: "Agents",
        key: "agents",
        route: "/trades-history/agents",
        component: Agents,
        isPrivate: true
      },
      {
        name: "Add new agent",
        key: "add-agent",
        route: "/trades-history/agent",
        component: Agent,
        isPrivate: true
      },
    ],
  },
  {
    type: "collapse",
    name: "Pages",
    key: "pages-seo",
    icon: <AiFillFund size="15px" color="inherit" />,
    mainLink: "/pages-seo",
    collapse: [
      {
        name: "Add page",
        key: "pages-seo-add",
        route: "/pages-seo/add",
        component: AddPage,
        isPrivate: true
      },
    ],
  },
  // {
  //   type: "collapse",
  //   name: "Tickets",
  //   key: "tickets",
  //   icon: <IoHelpBuoy size="15px" color="inherit" />,
  //   collapse: [
  //     {
  //       name: "All tickets",
  //       key: "all-tickets",
  //       route: "/tickets/all-tickets",
  //       component: Tickets,
  //       isPrivate: true
  //     },
  //   ],
  // },
  
  { route: "/users/user", component: EditUser, key: "user" },
  { route: "/tickets/ticket", component: Ticket, key: "tiket" },
  { route: "/deposits/deposit", component: EditDeposit, key: "edit-deposit" },
  { route: "/sign-in", component: SignInIllustration, key: "sign-in" },
  { route: "/payment-systems/edit", component: AddPs, key: "edit-ps" },
  { route: "/payment-systems/new-api", component: NewApi, key: "new-api" },
  { route: "/plans/plan", component: AddPlan, key: "edit-plan" },
  { route: "/conversion-plans/add", component: AddConversionPlan, key: "add-conv-plan" },
  { route: "/conversion-plans/edit", component: AddConversionPlan, key: "edit-conv-plan" },
  { route: "/crypto-addresses-generator/edit", component: AddCryptoAddressesGenerator, key: "edit-crypto-gen" },
  { route: "/reports-generator/show", component: ReportsGeneratorConfigsAdd, key: "edit-reports-config" },
  { route: "/trades-history", component: TradesHistory, key: "trades-history"},
  { route: "/transactions/all-transactions", component: TransactionsList, key: "all-transactions"},
  { route: "/transactions/transaction", component: EditTransaction, key: "edit-transaction"},
  { route: "/pages-seo", component: PagesSeoList, key: "pages-seo"},
  { route: "/pages-seo/update", component: AddPage, key: "pages-seo-update"},

  { route: "/promocodes/edit", component: PromocodesEdit, key: "promocodes-edit"},
  { route: "/promocodes/add", component: PromocodesAdd, key: "promocodes-add"},

  // { type: "title", title: "Pages", key: "title-pages" },
  // {
  //   type: "collapse",
  //   name: "Pages",
  //   key: "pages",
  //   icon: <IoDocument size="15px" color="inherit" />,
  //   collapse: [
  //     {
  //       name: "Profile",
  //       key: "profile",
  //       collapse: [
  //         {
  //           name: "Profile Overview",
  //           key: "profile-overview",
  //           route: "/pages/profile/profile-overview",
  //           component: ProfileOverview,
  //         },
  //         {
  //           name: "Teams",
  //           key: "teams",
  //           route: "/pages/profile/teams",
  //           component: Teams,
  //         },
  //         {
  //           name: "All Projects",
  //           key: "all-projects",
  //           route: "/pages/profile/all-projects",
  //           component: AllProjects,
  //         },
  //       ],
  //     },
      // {
      //   name: "Users",
      //   key: "users",
      //   collapse: [
      //     {
      //       name: "Reports",
      //       key: "reports",
      //       route: "/pages/users/reports",
      //       component: Reports,
      //     },
      //     {
      //       name: "New User",
      //       key: "new-user",
      //       route: "/pages/users/new-user",
      //       component: NewUser,
      //     },
      //   ],
      // },
  //     {
  //       name: "Account",
  //       key: "account",
  //       collapse: [
  //         {
  //           name: "Settings",
  //           key: "settings",
  //           route: "/pages/account/settings",
  //           component: Settings,
  //         },
  //         {
  //           name: "Billing",
  //           key: "billing",
  //           route: "/pages/account/billing",
  //           component: Billing,
  //         },
  //         {
  //           name: "Invoice",
  //           key: "invoice",
  //           route: "/pages/account/invoice",
  //           component: Invoice,
  //         },
  //       ],
  //     },
  //     {
  //       name: "Projects",
  //       key: "projects",
  //       collapse: [
  //         {
  //           name: "General",
  //           key: "general",
  //           route: "/pages/projects/general",
  //           component: General,
  //         },
  //         {
  //           name: "Timeline",
  //           key: "timeline",
  //           route: "/pages/projects/timeline",
  //           component: Timeline,
  //         },
  //       ],
  //     },
  //     {
  //       name: "Pricing Page",
  //       key: "pricing-page",
  //       route: "/pages/pricing-page",
  //       component: PricingPage,
  //     },
  //     { name: "RTL", key: "rtl", route: "/pages/rtl", component: RTL },
  //     { name: "Widgets", key: "widgets", route: "/pages/widgets", component: Widgets },
  //     { name: "Charts", key: "charts", route: "/pages/charts", component: Charts },
  //     {
  //       name: "Alerts",
  //       key: "alerts",
  //       route: "/pages/alerts",
  //       component: Alerts,
  //     },
  //   ],
  // },
  // {
  //   type: "collapse",
  //   name: "Applications",
  //   key: "applications",
  //   icon: <IoBuild size="15px" color="inherit" />,
  //   collapse: [
  //     {
  //       name: "Kanban",
  //       key: "kanban",
  //       route: "/applications/kanban",
  //       component: Kanban,
  //     },
  //     {
  //       name: "Wizard",
  //       key: "wizard",
  //       route: "/applications/wizard",
  //       component: Wizard,
  //     },
  //     {
  //       name: "Data Tables",
  //       key: "data-tables",
  //       route: "/applications/data-tables",
  //       component: DataTables,
  //     },
  //     {
  //       name: "Calendar",
  //       key: "calendar",
  //       route: "/applications/calendar",
  //       component: Calendar,
  //     },
  //   ],
  // },
  
  // {
  //   type: "collapse",
  //   name: "Authentication",
  //   key: "authentication",
  //   icon: <IoDocuments size="15px" color="inherit" />,
  //   collapse: [
  //     {
  //       name: "Sign In",
  //       key: "sign-in",
  //       collapse: [
  //         // {
  //         //   name: "Basic",
  //         //   key: "basic",
  //         //   route: "/authentication/sign-in/basic",
  //         //   component: SignInBasic,
  //         // },
  //         // {
  //         //   name: "Cover",
  //         //   key: "cover",
  //         //   route: "/authentication/sign-in/cover",
  //         //   component: SignInCover,
  //         // },
  //         {
  //           name: "Illustration",
  //           key: "illustration",
  //           route: "/authentication/sign-in/illustration",
  //           component: SignInIllustration,
  //         },
  //       ],
  //     },
  //     // {
  //     //   name: "Sign Up",
  //     //   key: "sign-up",
  //     //   collapse: [
  //     //     {
  //     //       name: "Basic",
  //     //       key: "basic",
  //     //       route: "/authentication/sign-up/basic",
  //     //       component: SignUpBasic,
  //     //     },
  //     //     {
  //     //       name: "Cover",
  //     //       key: "cover",
  //     //       route: "/authentication/sign-up/cover",
  //     //       component: SignUpCover,
  //     //     },
  //     //     {
  //     //       name: "Illustration",
  //     //       key: "illustration",
  //     //       route: "/authentication/sign-up/illustration",
  //     //       component: SignUpIllustration,
  //     //     },
  //     //   ],
  //     // },
  //   ],
  // },
];

export default routes;
